import { memo } from 'react';
import FloatingMenu from '../widgets/FloatingMenu';
import { ReviewerCopilotButton } from './buttons/copilot';

function PlainTextFloatingMenu() {
  return (
    <>
      <FloatingMenu
        name="PlaintextFloatingMenu"
        shouldShow={({ editor }) => !editor.state.selection.empty}
      >
        <ReviewerCopilotButton />
      </FloatingMenu>
    </>
  );
}

export default memo(PlainTextFloatingMenu);
